module.exports = __webpack_public_path__ + "static/media/Ar-Rahman.7b613242.jpg";